/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Combobox } from '@neo4j-ndl/react';

const Component = () => {
  let options = [
    {
      label: 'Group 1',
      options: [
        { label: 'Option 1', value: 'option-1' },
        { label: 'Option 2', value: 'option-2' },
        { label: 'Option 3', value: 'option-3' },
      ],
    },
    {
      label: 'Group 2',
      options: [
        { label: 'Option 4', value: 'option-4' },
        { isDisabled: true, label: 'Option 5', value: 'option-5' },
        { label: 'Option 6', value: 'option-6' },
        { label: 'Option 7', value: 'option-7' },
      ],
    },
  ];

  return <Combobox label="Products by category" options={options} />;
};

export default Component;
